import React from 'react';
import PropTypes from 'prop-types';
import MoveTo from 'moveto';
import { menuToggler } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import FilterBar from './FilterBar';
import AppliedFilters from './AppliedFilters';
import { colors } from '../styles';

const styles = css`
  .FilterSort_wrapper {
    display: none;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors.neutralDark};
    padding: 60px 15px;
    overflow-y: scroll;
    &.active {
      display: block;
    }
    @media (min-width: 992px) {
      display: flex;
      position: relative;
      z-index: 5;
      padding: 0;
      overflow-y: visible;
      border-top: 1px solid ${colors.neutral};
      border-bottom: 1px solid ${colors.neutral};
      justify-content: space-between;
      background-color: ${colors.white};
    }
  }
  .FilterSort_closeBtn {
    width: 18px;
    height: 18px;
    position: absolute;
    right: 15px;
    top: 15px;
    display: block;
    background-image: url('/images/icon-close.svg');
    background-size: 18px 18px;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .FilterSort_doneBtn {
    margin: 15px 0 0 0;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .FilterSort_toggle {
    position: relative;
    display: flex;
    align-items: center;
    z-index: 2;
    cursor: pointer;
    height: 40px;
    padding: 5px 8px;
    background-color: ${colors.white};
    width: auto;
    text-align: center;
    border: 1px solid ${colors.neutralDarker};
    border-radius: 3px;
    font-weight: 700;
    margin: 10px 5px 10px 15px;
    font-size: 12px;
  }
  .Sort_buttonMobile {
    position: relative;
    display: flex;
    flex-direction: row;
    z-index: 3;
    cursor: pointer;
    height: 40px;
    flex-grow: 0;
    flex-shrink: 0;
    padding: 0 10px;
    align-items: center;
    border: 1px solid ${colors.neutralDarker};
    border-radius: 3px;
    margin: 10px 5px;
    font-size: 12px;
    &::after {
      content: '';
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid ${colors.brand3};
      position: relative;
      margin: 0 0 0 5px;
    }
  }
  .Sort_buttonMobileLabel {
    font-weight: 800;
    margin: 0 5px 0 0;
  }
  .Sort_buttonDesktop {
    display: none;
    @media (min-width: 992px) {
      position: relative;
      display: flex;
      flex-direction: row;
      z-index: 2;
      cursor: pointer;
      height: 50px;
      flex-grow: 0;
      flex-shrink: 0;
      padding: 0 15px;
      align-items: center;
      width: auto;
      padding: 0 20px;
      border-left: 1px solid ${colors.neutral};
      border-right: 1px solid ${colors.neutral};
    }
    &::after {
      content: '';
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid ${colors.brand3};
      position: relative;
      margin: 0 0 0 5px;
    }
  }
  .Sort_buttonDesktopLabel {
    font-weight: 800;
    margin: 0 5px 0 0;
  }
  .Sort_dropdown {
    position: absolute;
    left: 0;
    top: 40px;
    width: 100%;
    list-style: none;
    padding: 0 10px;
    background: ${colors.white};
    box-shadow: 0 10px 15px 0 rgba(0,0,0,0.50);
    background-color: ${colors.white};
    width: auto;
    @media (min-width: 992px) {
      left: auto;
      right: 0;
      top: 50px;
    }
  }
  .Sort_dropdownItem {
    font-weight: 300;
    font-size: 14px;
    line-height: 1.5;
    color: ${colors.body};
    border-bottom: 1px solid ${colors.neutral};
    width: 100%;
    display: block;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
    &:last-child {
      border: 0;
    }
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  .Sort_dropdownItemButton {
    width: 100%;
    padding: 10px 0;
    display: block;
  }
  .ResetFilter_button {
    position: relative;
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    background-color: ${colors.white};
    padding: 4px 21px 4px 8px;
    color: ${colors.body};
    border: 1px solid ${colors.neutral};
    border-radius: 3px;
    background-image: url('/images/icon-refresh-gray.svg');
    background-position: calc(100% - 7px) center;
    background-repeat: no-repeat;
    background-size: 10px 10px;
    cursor: pointer;
    @media (min-width: 992px) {
      font-size: 13px;
    }
  }
  .ShowMap_button {
    position: relative;
    display: flex;
    flex-direction: row;
    z-index: 2;
    cursor: pointer;
    height: 40px;
    flex-grow: 0;
    flex-shrink: 0;
    padding: 0 10px;
    align-items: center;
    border: 1px solid ${colors.neutralDarker};
    border-radius: 3px;
    margin: 10px 15px;
    font-size: 12px;
    @media (min-width: 992px) {
      margin: 5px 15px;
    }
    img {
      height: 14px;
      margin: 0 4px 0 0;
    }
  }
  .AppliedFilters_wrapper {
    padding: 0 10px;
    @media (min-width: 992px) {
      padding: 0 20px;
    }
  }
`;

function scrollToTop(ref) {
  setTimeout(() => {
    const moveTo = new MoveTo({
      tolerance: 100,
    });
    moveTo.move(ref);
  }, 100);
}

class Filters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filtersOpen: false,
    };
  }

  openFilters = () => {
    this.setState({
      filtersOpen: true,
    });
  }

  closeFilters = () => {
    this.setState({
      filtersOpen: false,
    });
  }

  render() {
    const {
      activateMenu, isActiveMenu, activeSort,
      sortOptions, onSortSelect, scrollRef,
      showMap, onToggleMap, hideOnDesktop,
    } = this.props;

    const { filtersOpen } = this.state;

    return (
      <div className={styles}>
        <div className="d-flex d-lg-none justify-content-between">
          <div className="d-flex">
            <span className="FilterSort_toggle d-lg-none" role="button" tabIndex="0" onClick={this.openFilters}>
              <span className="FilterSort_toggleLabel">Filters</span>
            </span>
            <div className="Sort_buttonMobile" role="button" tabIndex="0" onClick={activateMenu('sort')}>
              <span className="Sort_buttonMobileLabel">Sorted By:</span> {activeSort.title}
              {
                isActiveMenu('sort') &&
                <ul className="Sort_dropdown">
                  { sortOptions.map(option => (
                    <li className="Sort_dropdownItem" key={option.title}>
                      <span
                        className="Sort_dropdownItemButton"
                        role="button"
                        tabIndex="0"
                        onClick={e => {
                          e.preventDefault();
                          scrollToTop(scrollRef);
                          onSortSelect(option);
                          activateMenu();
                        }}
                      >
                        {option.title}
                      </span>
                    </li>
                  ))}
                </ul>
              }
            </div>
          </div>
          {
            onToggleMap &&
            !showMap &&
            <span className={`ShowMap_button ${hideOnDesktop && 'd-lg-none'}`} role="button" tabIndex="0" onClick={() => onToggleMap(!showMap)}>
              <img src="/images/icon-map-pin.svg" alt="" />
              <span className="ShowMap_buttonLabel">Map</span>
            </span>
          }
          {
            onToggleMap &&
            showMap &&
            <span className={`ShowMap_button ${hideOnDesktop && 'd-lg-none'}`} role="button" tabIndex="0" onClick={() => onToggleMap(!showMap)}>
              <img src="/images/icon-list.svg" alt="" />
              <span className="ShowMap_buttonLabel">List</span>
            </span>
          }
        </div>
        <div className={`FilterSort_wrapper ${filtersOpen && 'active'}`}>
          <button className="FilterSort_closeBtn" onClick={this.closeFilters} />
          <FilterBar
            {...this.props}
          />
          <div className="d-flex">
            <div className="Sort_buttonDesktop" role="button" tabIndex="0" onClick={activateMenu('sort')}>
              <span className="Sort_buttonDesktopLabel">Sorted By: </span><span>{activeSort.title}</span>
              {
                isActiveMenu('sort') &&
                <ul className="Sort_dropdown">
                  { sortOptions.map(option => (
                    <li className="Sort_dropdownItem" key={option.title}>
                      <span
                        className="Sort_dropdownItemButton"
                        role="button"
                        tabIndex="0"
                        onClick={e => {
                          e.preventDefault();
                          scrollToTop(scrollRef);
                          onSortSelect(option);
                          activateMenu();
                        }}
                      >
                        {option.title}
                      </span>
                    </li>
                  ))}
                </ul>
              }
            </div>
            {
              onToggleMap &&
              showMap &&
              <span className={`ShowMap_button d-none d-lg-flex ${hideOnDesktop}`} role="button" tabIndex="0" onClick={() => onToggleMap(!showMap)}>
                <img src="/images/icon-map-pin.svg" alt="" />
                <span className="ShowMap_buttonLabel">Map</span>
              </span>
            }
            {
              onToggleMap &&
              !showMap &&
              <span className={`ShowMap_button d-none d-lg-flex ${hideOnDesktop}`} role="button" tabIndex="0" onClick={() => onToggleMap(!showMap)}>
                <img src="/images/icon-list.svg" alt="" />
                <span className="ShowMap_buttonLabel">List</span>
              </span>
            }
          </div>
          <button className="btn btn-small FilterSort_doneBtn" onClick={this.closeFilters}>Done</button>
        </div>
        <div className="AppliedFilters_wrapper">
          <AppliedFilters
            {...this.props}
            clearButton={<span className="ResetFilter_button">Clear Filters</span>}
          />
        </div>
      </div>
    );
  }
}

Filters.propTypes = {
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  onSortSelect: PropTypes.func.isRequired,
  onToggleMap: PropTypes.func,
  sortOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeSort: PropTypes.object.isRequired,
  scrollRef: PropTypes.object,
  showMap: PropTypes.bool,
  hideOnDesktop: PropTypes.bool,
};

Filters.defaultProps = {
  scrollRef: document.getElementsByTagName('body')[0],
  onToggleMap: undefined,
  showMap: undefined,
  hideOnDesktop: undefined,
};

export default menuToggler(Filters);



// WEBPACK FOOTER //
// ./src/components/Filters.js